module.exports = __webpack_public_path__ + "static/media/iStock-1172233289.16de4418.jpg";